import React from 'react';
import numeral from 'numeral';

const SocialBar = ({ influencerId, data, dataTotal }) => {
  const computeWidth = dataItem => {
    const amount = dataItem / dataTotal * 100;
    return amount + '%';
  };

  return (
    <div>
      <div className="social-bar">
        {data.map(item => (
          <div
            className={'line-item ' + item.channel}
            style={{ width: computeWidth(item.count) }}
            key={item.channel}
          />
        ))}
      </div>
      <div className="social-bar-labels">
        {data.map(item => (
          <div className="label" key={item.channel}>
            <img src={`/icons/${item.channel}.svg`} alt={item.channel} />
            <p className="small light">
              {item.count > 0 ? numeral(item.count).format('0a') : '-'}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialBar;



/** WEBPACK FOOTER **
 ** ./src/components/social-bar/index.js
 **/